var _dec, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { isPresent } from '@ember/utils';
import DeviceProfileV2, { DeviceProfileTypeKeys } from '@square/dashboard-data/models/device-profiles-v2/device-profile-v2';
import { DeviceProfileType } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/model/shared/device_profile_type';
import { FNBKioskDiningOption } from '@square/dashboard-data/models/device-profiles-v2/settings/fnb-kiosk-settings';
let KioskProfilesService = (_dec = service('device-profiles-v2/device-profile-v2'), _class = class KioskProfilesService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "deviceProfileV2Service", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
  }
  async createProfileWithDefaultSettings(defaultSettingName, isShared) {
    const defaultKioskProfile = await this.deviceProfileV2Service.getDefaultProfile(DeviceProfileType.FNBKIOSK);
    const defaultDeviceProfile = DeviceProfileV2.fromProto(defaultKioskProfile.deviceProfile);
    const defaultDiningOptions = await this.getDefaultDiningOptions();
    if (isPresent(defaultDeviceProfile.profileSettings.fnbKiosk)) {
      defaultDeviceProfile.profileSettings.fnbKiosk.set('diningOptions', defaultDiningOptions);
    }
    if (defaultKioskProfile.deviceProfile) {
      const deviceProfile = DeviceProfileV2.create({
        name: defaultSettingName,
        type: DeviceProfileTypeKeys.FNBKIOSK,
        shared: isShared,
        profileSettings: defaultDeviceProfile.profileSettings
      });
      const profile = await this.deviceProfileV2Service.deprecatedCreateDeviceProfile(deviceProfile);
      return profile;
    } else {
      const profile = await this.createDefaultSettings(defaultSettingName, isShared);
      return DeviceProfileV2.fromProto(profile);
    }
  }
  updateDiningOptions(deviceProfile, diningOptions) {
    const newDiningOptions = diningOptions.map((diningOption, i) => ({
      diningOptionId: diningOption.id,
      kioskOrdinal: i
    }));
    const updatedProfile = deviceProfile;
    updatedProfile.fnbKioskSettings.fnbKiosk.diningOptions = newDiningOptions;
    this.deviceProfileV2Service.updateDeviceProfile(updatedProfile);
  }

  /**
   * Retrieve dining option for default kiosk setting.
   * @returns The first two dining options if there are more than two or one dining option if there is only one
   */
  async getDefaultDiningOptions() {
    const diningOptions = await this.store.findAll('dining-option');
    let filteredDiningOptions = diningOptions.toArray().filter(diningOption => diningOption.globallyEnabled || diningOption.disabledUnits.length === 0);
    if (filteredDiningOptions.length === 0) {
      // Kiosk requires at least one dining option. If there are no existing dining options, create a default one:
      const defaultDiningOption = this.store.createRecord('dining-option', {
        name: this.intl.t('items.diningOptions.default.forHere'),
        ordinal: 1
      });
      await defaultDiningOption.save();
      filteredDiningOptions = [defaultDiningOption];
    }
    if (filteredDiningOptions.length > 1) {
      // Use first two dining options as default kiosk dining option settings values
      filteredDiningOptions = filteredDiningOptions.sort((diningOptionA, diningOptionB) => diningOptionA.ordinal - diningOptionB.ordinal).slice(0, 2);
    }
    return filteredDiningOptions.map((diningOption, i) => FNBKioskDiningOption.create({
      diningOptionId: diningOption.id,
      kioskOrdinal: i
    }));
  }
  async createDefaultSettings(defaultSettingName, isShared) {
    const profile = await this.deviceProfileV2Service.createDefaultDeviceProfile(defaultSettingName, DeviceProfileType.FNBKIOSK, undefined, isShared);
    return profile;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "deviceProfileV2Service", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { KioskProfilesService as default };